import { apiFetch } from './api';

export interface ExperimentDetailsValues {
  name: string;
  description: string;
}

interface ExperimentDetailsResponse {
  status_message?: string;
  data?: {
    experiment?: {
      name?: unknown;
      description?: unknown;
    };
  };
}

export class ExperimentDetailsUpdateError extends Error {
  readonly status: number;

  constructor(message: string, status: number) {
    super(message);
    this.name = 'ExperimentDetailsUpdateError';
    this.status = status;
  }
}

export function normalizeExperimentDetails(
  values: ExperimentDetailsValues,
): ExperimentDetailsValues {
  return {
    name: values.name.trim(),
    description: values.description.trim(),
  };
}

export async function updateExperimentDetails(
  externalUuid: string,
  values: ExperimentDetailsValues,
): Promise<ExperimentDetailsValues> {
  const normalized = normalizeExperimentDetails(values);
  const response = await apiFetch(`/api/experiments/${externalUuid}/`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(normalized),
  });
  const payload = (await response.json().catch(() => ({}))) as ExperimentDetailsResponse;

  if (!response.ok) {
    throw new ExperimentDetailsUpdateError(
      payload.status_message ?? `Failed to update experiment (${response.status}).`,
      response.status,
    );
  }

  const experiment = payload.data?.experiment;
  if (typeof experiment?.name !== 'string' || typeof experiment.description !== 'string') {
    throw new ExperimentDetailsUpdateError('Failed to update experiment.', response.status);
  }

  return {
    name: experiment.name,
    description: experiment.description,
  };
}
